import type { ReactElement, ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { AuthPageLoading } from "@/components/layout/AuthPageShell";
import { AuthLoadError } from "@/components/shared/AuthLoadError";
import { useAuth } from "@/hooks/useAuth";
import { resolveAccessLockRoute } from "@/lib/accessLockCopy";

type RequireActiveAccessProps = {
  children?: ReactNode;
};

export function RequireActiveAccess({ children }: RequireActiveAccessProps): ReactElement {
  const { user, isLoading, isError, refetch } = useAuth();

  if (isLoading) return <AuthPageLoading />;

  if (isError) return <AuthLoadError onRetry={refetch} />;

  if (!user) return <Navigate to="/login" replace />;
  if (user.accessLock) {
    return <Navigate to={resolveAccessLockRoute(user.accessLock)} replace />;
  }

  if (children != null) {
    return <>{children}</>;
  }

  return <Outlet />;
}
